module.controller(
    'sampleElementListCtrl',
    [ '$scope', '$rootScope', '$state', 'sampleElementService', 'alertService', 'roleService', 'parameterService',
        function($scope, $rootScope, $state, sampleElementService, alertService, roleService, parameterService) {

            $scope.filter = {
                visible: true,
                type:null
            };
            $scope.samplesElements = [];
            $scope.pagination = {
                current : 1,
                total : 0
            };

            /**
             *
             * @param page
             */
            $scope.search = function(page) {
                $scope.loading = true;

                page = page == undefined ? 1 : page;
                $scope.pagination.current = page;

                var filter = {};
                filter.offset = (page - 1) * $rootScope.pageSize;
                filter.limit = $rootScope.pageSize;
                filter.visible = $scope.filter.visible;

                if($scope.filter.name){
                    filter.name = $scope.filter.name;
                }
                
                if($scope.filter.type && $scope.filter.type[0]){
                    filter.sampleElementType = $scope.filter.type[0].enumName;
                }

                sampleElementService.searchSamplesElements(filter).then(function(response) {
                    $scope.loading = false;
                    var result = response.getData();

                    $scope.samplesElements = result.results;
                    $scope.pagination.total = result.totalRegisters;

                }, function(response) {
                    $scope.loading = false;
                });                
            };

            $scope.remove = function(id) {
            	var se = $scope.samplesElements.find(function(sec){ return sec.id == id; })
                alertService.showSwtQuestion('Eliminar elemento de muestreo "'+se.name+'"', function() {
                    $scope.loading = true;

                    sampleElementService.deleteSampleElement(id).then(function(response) {
                        $scope.loading = false;
                        $scope.search(1);
                        alertService.showSuccess('Elemento de muestreo eliminado satisfactoriamente');
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };

            /**
             *
             */
            $scope.clearFilters = function(){
            	$scope.filter = {
                        visible: true,
                        type:null
                    };
            };

            $scope.search(1);

        } ]);
